import request from '@/utils/request'

// 조회
export function getWorkStoppages(param, isNotify) {
  return request({
    url: '/api/getWorkStoppages',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}
// 디테일 조회
export function getWorkStoppageDetail(param, isNotify) {
  return request({
    url: '/api/getWorkStoppageDetail',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}
// 저장
export function saveWorkStoppages(param, isNotify) {
  return request({
    url: '/api/saveWorkStoppages',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved, deleted
  })
}
// 삭제
export function deleteWorkStoppages(param, isNotify) {
  return request({
    url: '/api/deleteWorkStoppages',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved, deleted
  })
}

// 조회
export function getCurrentConstruct(param, isNotify) {
  return request({
    url: '/api/getCurrentConstruct',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}
export function getConstructs(param, isNotify) {
  return request({
    url: '/api/getConstructs',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}

export function getWorkStoppageReport (params, isProgress) {
  let responseType = "blob"
  return request({
    url: `/api/getWorkStoppageReport`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    responseType: responseType,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' },
  })
}